module.exports = __webpack_public_path__ + "c4881ade55104d82b3c048506b5837cd.svg";